import { createPortal } from 'react-dom'

export default function ConfirmModal({ title, message, confirmLabel = 'Confirm', cancelLabel = 'Cancel', onConfirm, onCancel, danger = false, success = false, confirmStyle }) {
  const btnStyle = confirmStyle ?? (danger
    ? { background: 'rgba(248,113,113,0.15)', color: '#f87171', border: '1px solid rgba(248,113,113,0.3)' }
    : success
      ? { background: 'rgba(52,211,153,0.15)', color: '#34d399', border: '1px solid rgba(52,211,153,0.3)' }
      : { background: 'var(--brand)', color: '#fff', border: 'none' })

  const iconBg = danger
    ? 'rgba(248,113,113,0.12)'
    : success
      ? 'rgba(52,211,153,0.12)'
      : 'var(--surface-2)'

  const icon = danger ? '⚠️' : success ? '✅' : '❓'

  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-center justify-center px-4"
         style={{ background: 'rgba(0,0,0,0.82)', backdropFilter: 'blur(6px)' }}
         onClick={onCancel}>
      <div className="w-full max-w-sm rounded-2xl border p-6 animate-fade-up"
           style={{ background: 'var(--surface)', borderColor: 'var(--border)', boxShadow: '0 24px 64px rgba(0,0,0,0.5)' }}
           onClick={e => e.stopPropagation()}>

        <div className="flex flex-col items-center text-center mb-6">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center text-xl mb-4"
               style={{ background: iconBg }}>
            {icon}
          </div>
          <h3 className="text-base font-bold mb-1.5" style={{ color: 'var(--text-1)' }}>{title}</h3>
          <p className="text-sm leading-relaxed" style={{ color: 'var(--text-2)' }}>{message}</p>
        </div>

        <div className="flex gap-2">
          <button onClick={onCancel} className="btn-ghost flex-1 justify-center">
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl font-semibold text-sm transition-all"
            style={btnStyle}
            onMouseEnter={e => {
              // A custom confirmStyle means the caller wants full control over
              // the button's look — don't override its color with the
              // danger/success hover tint underneath it.
              if (confirmStyle) return
              if (danger)   e.currentTarget.style.background = 'rgba(248,113,113,0.25)'
              if (success)  e.currentTarget.style.background = 'rgba(52,211,153,0.25)'
            }}
            onMouseLeave={e => {
              if (confirmStyle) return
              if (danger)   e.currentTarget.style.background = 'rgba(248,113,113,0.15)'
              if (success)  e.currentTarget.style.background = 'rgba(52,211,153,0.15)'
            }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}
